import type { FC, PropsWithChildren } from 'react';

/**
 * Type guard useful for union types that also narrow type when used in if statement
 * @example
 * ```ts
 * const x: '1'|'2'|'3'|'4'|'5' = '1';
 * if (isOneOf(x, ['1', '2'])) {
 *   x; // type narrowed to '1' | '2'
 * }
 * ```
 */
export const isOneOf = <const TThing, TListOfThings extends TThing[]>(
  thing: TThing,
  listOfThings: TListOfThings,
): thing is TListOfThings[number] => listOfThings.includes(thing);

/**
 * This type allows any string but helps intellisense/autocomplete to suggest the correct values
 */
export type LoseStringUnion<T> = T | (string & {});

export type FCC<T = unknown> = FC<PropsWithChildren<T>>;

export type FirstArgOf<T extends (...args: any) => any> = Parameters<T>[0];

export type AwaitedReturnType<T extends (...args: any) => any> = Awaited<ReturnType<T>>;

export type Branded<K, T> = K & { __brand: T };
